import { HardwareModels } from "types/productTypes";

export const generateProductUuid = (hardwareModel: string, serialNo: string) => {
  const uuid = hardwareModel + "-" + serialNo;
  return uuid;
};

export const getHardwareModelFromPid = (pid: string | null | undefined): HardwareModels | null => {
  const prefix = pid?.split("-")[0];
  const models = Object.values(HardwareModels) as string[];
  return prefix && models.includes(prefix) ? (prefix as HardwareModels) : null;
};

export const isSingleControllerDevice = (pid: string | null | undefined): boolean =>
  getHardwareModelFromPid(pid) === HardwareModels.Dpvr;

export const hardwareReportsControllerState = (
  hardwareModel: HardwareModels | null | undefined,
): boolean => hardwareModel !== HardwareModels.HtcFocusVision;

export const reportsControllerState = (pid: string | null | undefined): boolean =>
  hardwareReportsControllerState(getHardwareModelFromPid(pid));

export const getProductHardwareLabel = (hardwareModel: HardwareModels): string => {
  switch (hardwareModel) {
    case HardwareModels.PicoNeo3ProEye:
      return "Pico Neo 3 Pro Eye";
    case HardwareModels.Pico4Enterprise:
      return "Pico 4 Enterprise";
    case HardwareModels.Dpvr:
      return "DPVR";
    case HardwareModels.PicoSwan:
      return "Pico Swan";
    case HardwareModels.HtcFocusVision:
      return "HTC VIVE Focus Vision";
    default:
      return hardwareModel;
  }
};

type ProductWithVrDate = {
  vrDate?: string | Date;
};
export const productSort = (productA: ProductWithVrDate, productB: ProductWithVrDate): number => {
  if (!productA.vrDate) return 1;
  if (!productB.vrDate) return -1;
  return new Date(productB.vrDate).getTime() - new Date(productA.vrDate).getTime();
};

const KNOWN_HARDWARE_PREFIXES = new Set(["pn3", "p4e"]);

export const getDeviceImg = (uuid: string): string => {
  const prefix = uuid.split("-")[0];
  const file = KNOWN_HARDWARE_PREFIXES.has(prefix) ? `${prefix}.png` : "p4e.png";
  return `/img/${file}`;
};
